import { Pipe, PipeTransform } from "@angular/core";
import _ from 'lodash';

@Pipe({ name: 'HolidayStatusPipe' })
export class HolidayStatusPipe implements PipeTransform {
    transform(value: string): string {
        if (value === "Inherited") {
            return "_General_Inherited_Text_";
        } else if (value === "Overridden") {
            return "_Location_Overridden_Ts_Text_";
        }

        throw new Error("Unexpected code path reached!")
    }
}
